import axios from 'axios';

export const getNewstList = id => axios.get(`/ess/api/news/${id}`);

export const getLatestNewstList = (pagination) => axios.get(`/ess/api/news/latest-news`, {
    params: {
        ...pagination
      }
});

export const createNewstList = data => axios.post(`/ess/api/news/create`, data);

export const updateeNewstList = (id, data) => axios.put(`/ess/api/news/${id}`, data);

export const deleteNews = id => axios.delete(`/ess/api/news/${id}`);


export const getTutorialsList = (pagination) => axios.get(`/ess/admin/api/onlinetutorials/latest-onlinetutorials`, {
    params: {
        ...pagination
      }
});

export const getNewFeaturesList = (pagination) => axios.get(`/ess/admin/api/newfeatures/latest-features`, {
    params: {
        ...pagination
      }
});